module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Louie Isaaman-Jones","short_name":"Louie I-J","start_url":"/","background_color":"#ffffff","display":"minimal-ui","icon":"static/louie-isaaman-jones-favicon-2.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"01836c15ae2983af12ac98c4897bfb73"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
